import JavaIcon from './Java_Icon.png';
import CppIcon from './Cpp_Icon.png';
import RustIcon from './Rust_Icon.png';
import GoLangIcon from './Go_Lang_Icon.png';

import WebDevIcon from './Web_Dev_Icon.png';
import ReactIcon from './React_Icon.png';

import PythonIcon from './Python_Icon.png';
import AiMlIcon from './AI_ML_Icon.png';
import QuantumComputingIcon from './Quantum_Computing_Icon.png';

import DefaultCategoryIcon from './Default_Category_Icon.png';



const CategoryList = [
    {
        "name": "Web Dev",
        "icon": WebDevIcon
    }, {
        "name": "QC",
        "icon": QuantumComputingIcon
    }, {
        "name": "AI/ML",
        "icon": AiMlIcon
    }, {
        "name": "Java",
        "icon": JavaIcon
    }, {
        "name": "Python",
        "icon": PythonIcon
    }, {
        "name": "Rust",
        "icon": RustIcon
    }, {
        "name": "C++",
        "icon": CppIcon
    }, {
        "name": "Go Lang",
        "icon": GoLangIcon
    }, {
        "name": "React",
        "icon": ReactIcon
    }, {
        "name": "Default",
        "icon": DefaultCategoryIcon
    }
]

export default CategoryList;